import { Event } from '@domain/event';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

const getEventByIdFetch = async (eventId?: string) => {
  if (!eventId) return null;
  const url = `${import.meta.env.VITE_EVENTS_HOST}/v1/nightgraph/events/${eventId}`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetEvent = ({
  eventId,
  options,
}: {
  eventId?: string;
  options?: Record<string, boolean | number>;
  handleLoading?: boolean;
}) => {
  return useGenericQuery<Event, RequestError>(['event-by-id', eventId], () => getEventByIdFetch(eventId), {
    ...options,
    enabled: (options?.enabled as boolean) ?? !!eventId,
    staleTime: (options?.staleTime as number) ?? 0,
    cacheTime: (options?.cacheTime as number) ?? 0,
  });
};
